import prop from "../utils/prop";
import { CurrencySymbol } from "@skywind-group/sw-money-formatter/dist/es5/constants";
export var getCurrencyByKey = function (key) { return prop(CurrencySymbol, key, key); };
